module.exports = __webpack_public_path__ + "assets/616a9dcdfbf4a30787c463a91873837c.png";